import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";

import ShipmentEnquiryTable from "../../components/ShipmentEnquiry/ShipmentEnquiryTable";
import ShipmentEnquiryV2 from "../../components/ShipmentEnquiry/ShipmentEnquiryV2";



const ShipmentEnquiriesPage = () => {
    return (
        <>
        
            <MasterLayout>

                <Breadcrumb title="Shipment Enquiry" />


                <ShipmentEnquiryV2/>
           



            </MasterLayout>
        </>
    );
};

export default ShipmentEnquiriesPage;
